"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabRequisitionsProvider = void 0;
const react_1 = __importStar(require("react"));
const OrganizationContext_1 = require("./OrganizationContext");
const LabRequisitionsContext_1 = require("./LabRequisitionsContext");
const LabRequisitionsProvider = ({ children, }) => {
    const { selectedOrgUser } = (0, react_1.useContext)(OrganizationContext_1.OrganizationContext);
    const [reactiveLabRequisitions, setReactiveLabRequisitions] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        let removeChangeListener;
        if (selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.labsManager) {
            removeChangeListener =
                selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.labsManager.registerChangeListener((labRequisitions) => {
                    setReactiveLabRequisitions(() => ({
                        labRequisitions,
                    }));
                });
        }
        return () => {
            if (removeChangeListener) {
                removeChangeListener();
            }
        };
    }, [selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.labsManager]);
    const setLabRequisitions = (labRequisitions) => {
        setReactiveLabRequisitions(() => labRequisitions
            ? { labRequisitions: labRequisitions }
            : undefined);
    };
    return (react_1.default.createElement(LabRequisitionsContext_1.LabRequisitionsContext.Provider, { value: {
            labRequisitions: reactiveLabRequisitions === null || reactiveLabRequisitions === void 0 ? void 0 : reactiveLabRequisitions.labRequisitions,
            setLabRequisitions,
        } }, children));
};
exports.LabRequisitionsProvider = LabRequisitionsProvider;
